import { ThemedIcon } from '@/design-system/icons';
import { IconName } from '@/design-system/icons/types';
import type { ReactNode } from 'react';

interface FormSectionProps {
  icon: IconName;
  title: string;
  children: ReactNode;
}

export function FormSection({ icon, title, children }: FormSectionProps) {
  return (
    <div className="flex flex-col gap-1 w-full mt-2">
      <div className="flex items-center gap-2 text-onsurface">
        <ThemedIcon name={icon} className='size-5' />
        <h2 className="text-lg font-semibold">{title}</h2>
      </div>
      <div className="pl-0 flex flex-col gap-3 w-full">
        {children}
      </div>
    </div>
  );
}


export function FormSectionInfo({ children }: {
  children: ReactNode;
}) {
  return (
    <div className='flex-row flex ml-1 mr-4 mb-1'>
      <div className='w-1 bg-onbackground/80 mr-2'/>
      <div className="text-sm text-onbackground/80">
        {children}
      </div>
    </div>
  );
}